import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { Suspense } from "react";
import PageContextProvider from "./context/PageContext";
import PageRoutes from "./routes";
import "react-loading-skeleton/dist/skeleton.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PageContextProvider>
        <Suspense>
          <PageRoutes />
        </Suspense>
      </PageContextProvider>
    </QueryClientProvider>
  );
}

export default App;
